import type { ConfiguratorModuleId, ConfiguratorProductId } from "../content/configurator";
import { getModule } from "../content/configurator";
import type { SelectablePageId } from "./configuratorPageCatalog";

/** Non-negotiable for any shop build — not optional toggles in step 3. */
export const ESHOP_CORE_MODULE_IDS: ConfiguratorModuleId[] = [
  "product-catalog",
  "cart-checkout",
  "payment-gateway",
  "admin-panel",
];

export function hasShopScope(
  productId: ConfiguratorProductId | "",
  selectedPages: SelectablePageId[] = [],
): boolean {
  if (!productId) return false;
  return productId === "eshop" || selectedPages.includes("shop");
}

export function getCoreModulesForState(
  productId: ConfiguratorProductId | "",
  selectedPages: SelectablePageId[] = [],
): ConfiguratorModuleId[] {
  if (!hasShopScope(productId, selectedPages)) return [];
  return [...ESHOP_CORE_MODULE_IDS];
}

export function mergeWithCoreModules(
  productId: ConfiguratorProductId | "",
  selectedPages: SelectablePageId[],
  modules: ConfiguratorModuleId[],
): ConfiguratorModuleId[] {
  const core = getCoreModulesForState(productId, selectedPages);
  return [...new Set([...modules, ...core])];
}

/** Keep core modules in sync when shop page is added or removed (e.g. on Website product). */
export function syncModulesWithScope(
  productId: ConfiguratorProductId | "",
  selectedPages: SelectablePageId[],
  modules: ConfiguratorModuleId[],
): ConfiguratorModuleId[] {
  const core = new Set(getCoreModulesForState(productId, selectedPages));
  const trimmed = modules.filter(
    (id) => !ESHOP_CORE_MODULE_IDS.includes(id) || core.has(id),
  );
  return mergeWithCoreModules(productId, selectedPages, trimmed);
}

export function isLockedModule(
  productId: ConfiguratorProductId | "",
  selectedPages: SelectablePageId[],
  moduleId: ConfiguratorModuleId,
): boolean {
  return getCoreModulesForState(productId, selectedPages).includes(moduleId);
}

export function getCoreModuleLabels(
  productId: ConfiguratorProductId | "",
  selectedPages: SelectablePageId[] = [],
): string[] {
  return getCoreModulesForState(productId, selectedPages).map((id) => getModule(id).title);
}
